const SpecialEventBanner = ({ children }: { children: string }) => {
  return (
    <div className="text-h/14_110 bg-white p-4 text-center font-semibold">
      {children}
    </div>
  )
}

export default SpecialEventBanner
